const C4 = 261.63;
const D4 = 293.66;
const E4 = 329.63;
const F4 = 349.23;
const G4 = 392.0;

// "Jingle Bells" chorus — [frequency, startTime(s), duration(s)]
const MELODY = [
  [E4, 0, 0.26], [E4, 0.3, 0.26], [E4, 0.6, 0.52],
  [E4, 1.2, 0.26], [E4, 1.5, 0.26], [E4, 1.8, 0.52],
  [E4, 2.4, 0.26], [G4, 2.7, 0.26], [C4, 3.0, 0.26], [D4, 3.3, 0.26], [E4, 3.6, 0.95],
  [F4, 4.7, 0.26], [F4, 5.0, 0.26], [F4, 5.3, 0.26], [F4, 5.6, 0.26],
  [F4, 5.9, 0.26], [E4, 6.2, 0.26], [E4, 6.5, 0.26], [E4, 6.8, 0.26],
  [E4, 7.1, 0.26], [D4, 7.4, 0.26], [D4, 7.7, 0.26], [E4, 8.0, 0.26],
  [D4, 8.3, 0.52], [G4, 8.9, 0.52],
];

export function playJingle(ctx) {
  const t0 = ctx.currentTime + 0.05;

  MELODY.forEach(([freq, t, dur]) => {
    const start = t0 + t;
    const stop = start + Math.max(dur + 0.25, 0.45);
    const osc = ctx.createOscillator();
    const shimmer = ctx.createOscillator();
    const gain = ctx.createGain();
    const shimmerGain = ctx.createGain();

    osc.type = "sine";
    osc.frequency.value = freq;
    shimmer.type = "sine";
    shimmer.frequency.value = freq * 2.7;
    shimmerGain.gain.value = 0.2;

    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.16, start + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, stop);

    osc.connect(gain);
    shimmer.connect(shimmerGain);
    shimmerGain.connect(gain);
    gain.connect(ctx.destination);

    osc.start(start);
    shimmer.start(start);
    osc.stop(stop + 0.05);
    shimmer.stop(stop + 0.05);
  });
}
